import {
  GET_TERMS_DLG,
  GET_TERMS_DLG_SUCCESS,
  GET_TERMS_DLG_ERROR,
  GET_TERMS_DLG_ERROR_MSG
} from "../constants/action-types";
import ApiService from "../../utils/ApiService";

export const fetchTermsDlg = async (dispatch, url) => {
  dispatch({
    type: GET_TERMS_DLG
  });
  try {
    const policy = await ApiService.getTermsAndConditions(url);
    if (policy) {
      dispatch({
        type: GET_TERMS_DLG_SUCCESS,
        payload: policy
      });
    } else {
      dispatch({
        type: GET_TERMS_DLG_ERROR,
        payload: GET_TERMS_DLG_ERROR_MSG
      });
    }
  } catch (error) {
    dispatch({
      type: GET_TERMS_DLG_ERROR,
      payload: GET_TERMS_DLG_ERROR_MSG
    });
  }
};
